import "../../../src/App.css";

import TrainList from "../../pages/SalesMasterPages/TrainListTest/TrainList";
import React, { useState, useEffect } from "react";
import axios from "axios";

import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function TrainApiTest() {
  const [regionResponse, setRegionResponse] = useState(null);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [regionId, setRegionId] = useState();

  const title = "Add Region";
  const heading = "Region List";

  const [trainData, setTrainData] = useState(null);

  useEffect(() => {
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: 'https://irctc1.p.rapidapi.com/api/v3/trainBetweenStations?fromStationCode=RUPC&toStationCode=NDLS&dateOfJourney=2023-11-02',
      headers: { 
        'X-RapidAPI-Key': 'd868e87d6emshd165c2992b3a253p1e7fe6jsn7efc154d8ee8', 
        'X-RapidAPI-Host': 'irctc1.p.rapidapi.com'
      }
    };

    axios.request(config)
      .then((response) => {
        setTrainData(response.data);
        // alert(trainData);
        // console.log(trainData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Region List| <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Region List</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                            
                <TrainList
                  trainData={trainData}
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                 
                />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TrainApiTest;
